<template>
  <div class="resource-out-container">
    <ds-page-header :title="$t('resourceOutManage.page.title')" :subtitle="$t('resourceOutManage.page.subtitle')">
      <template #extra>
        <span class="ds-num ds-order">{{ $t('resourceOutManage.orderId') }}：{{ resourceOutManageInfo.applyOrderId }}</span>
        <el-button type="primary" size="small" icon="el-icon-check" @click="handleSubmit" :loading="loading">
          {{ $t('resourceOutManage.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left><span class="ds-panel__title">{{ $t('resourceOutManage.page.title') }}</span></template>
      </ds-toolbar>
      <ds-data-table :data="resourceOutManageInfo.purchaseApplyDetailVo" :loading="loading" border
        :empty-description="$t('resourceOutManage.page.empty')">
        <el-table-column prop="rstName" :label="$t('resourceOutManage.itemType')" align="center" min-width="120">
          <template slot-scope="scope">{{ scope.row.rstName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="resName" :label="$t('resourceOutManage.itemName')" align="center" min-width="140" />
        <el-table-column prop="specName" :label="$t('resourceOutManage.itemSpec')" align="center" width="110">
          <template slot-scope="scope">{{ scope.row.specName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="resCode" :label="$t('resourceOutManage.itemCode')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resCode || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="stock" :label="$t('resourceOutManage.itemStock')" align="center" width="100">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.stock }}</span></template>
        </el-table-column>
        <el-table-column prop="quantity" :label="$t('resourceOutManage.applyQuantity')" align="center" width="100">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.quantity }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('resourceOutManage.issueQuantity')" align="center" min-width="160">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.purchaseQuantity" type="number"
              :placeholder="$t('resourceOutManage.issueQuantityPlaceholder')" @input="validateQuantity(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('resourceOutManage.remark')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.purchaseRemark" type="text" :placeholder="$t('resourceOutManage.remarkPlaceholder')" clearable />
          </template>
        </el-table-column>
      </ds-data-table>
    </div>
  </div>
</template>

<script>
import { listPurchaseApplys, submitResourceOut } from '@/api/resource/resourceOutManageApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'ResourceOutManageList',
  components: { DsPageHeader, DsToolbar, DsDataTable },
  data() {
    return {
      loading: false,
      resourceOutManageInfo: { purchaseApplyDetailVo: [], applyOrderId: '', taskId: '', resOrderType: '' }
    }
  },
  created() {
    this.resourceOutManageInfo.applyOrderId = this.$route.query.applyOrderId
    this.resourceOutManageInfo.resOrderType = this.$route.query.resOrderType
    this.resourceOutManageInfo.taskId = this.$route.query.taskId
    this.getList()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const params = {
          page: 1, row: 10,
          applyOrderId: this.resourceOutManageInfo.applyOrderId,
          resOrderType: this.resourceOutManageInfo.resOrderType
        }
        const data = await listPurchaseApplys(params)
        const purchaseApply = data.purchaseApplys[0]
        this.resourceOutManageInfo = { ...this.resourceOutManageInfo, ...purchaseApply }
        this.resourceOutManageInfo.purchaseApplyDetailVo.forEach(item => {
          item.purchaseQuantity = ''
          item.price = ''
          item.purchaseRemark = ''
        })
      } catch (error) {
        console.error('Failed to fetch purchase apply list:', error)
        this.$message.error(this.$t('resourceOutManage.fetchError'))
      } finally {
        this.loading = false
      }
    },
    validateQuantity(item) {
      if (item.purchaseQuantity && parseFloat(item.purchaseQuantity) > parseFloat(item.stock)) {
        this.$message.warning('出库数量不能超过库存数量')
      }
    },
    async handleSubmit() {
      try {
        let isValid = true
        this.resourceOutManageInfo.purchaseApplyDetailVo.forEach(item => {
          if (!item.purchaseQuantity || parseFloat(item.purchaseQuantity) <= 0) {
            this.$message.error(this.$t('resourceOutManage.quantityRequired'))
            isValid = false
            return
          }
          item.purchaseQuantity = parseFloat(item.purchaseQuantity)
          if (item.purchaseQuantity > parseFloat(item.stock)) {
            this.$message.error(this.$t('resourceOutManage.insufficientStock'))
            isValid = false
            return
          }
        })
        if (!isValid) return
        const response = await submitResourceOut(this.resourceOutManageInfo)
        if (response.code === 0) {
          this.$message.success(this.$t('common.operationSuccess'))
          this.$router.go(-1)
        } else {
          this.$message.error(response.msg)
        }
      } catch (error) {
        console.error('Failed to submit resource out:', error)
        this.$message.error(this.$t('resourceOutManage.submitError'))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-out-container { padding: var(--ds-spacing-lg); background-color: var(--ds-gray-100); min-height: calc(100vh - 60px); }
.ds-panel { background: #fff; border: 1px solid var(--ds-gray-300); border-radius: var(--ds-radius-md); box-shadow: var(--ds-shadow-sm); overflow: hidden; margin-bottom: var(--ds-spacing-lg);
  &__title { font-size: var(--ds-font-size-lg); font-weight: 600; color: var(--ds-gray-800); }
}
.ds-order { font-size: var(--ds-font-size-sm); color: var(--ds-gray-600); margin-right: var(--ds-spacing-md); }
</style>
